export default __webpack_public_path__ + "static/media/epi-carworkshop.087d9f5d.jpg";